<template>
  <step
    :context="context"
    image="/images/gift.svg"
    @back="$emit('back')"
    @submit="submit"
  >
    <template #guideTitle>Your new program is just around the corner</template>
    <template #guideDescription>
      <div>
        <b>2. Joining Gift—</b>Please specify exact check level discount amount that
        will incentivize your users to join your loyalty program.
      </div>
      <div>
        <b>3. Birthday Gift—</b>Please specify exact check level discount amount to
        give your users on their birthday.
      </div>
    </template>
    <template #formTitle>Core Loyalty Program Setup</template>
    <template #form>
      <v-form class="form" v-model="valid" ref="form">

        <!-- Joining Gift Discount -->
        <form-section
          header="2. Joining Gift—Cash Discount"
          tooltip="Como Sense Professional offers various discount options, such as percentage discount, free item, and more."
        >
          <div class="inline">
            <div>Enter <b>Check-Level</b> Discount</div>
            <v-text-field
              class="minimal"
              :suffix="model.joiningGiftDiscountPercetangeType ? '%' : null"
              :prefix="model.joiningGiftDiscountPercetangeType ? null : '$'"
              placeholder="5"
              v-model="model.joiningGiftDiscount"
              :rules="[rules.required, rules.number]"
            />
            <v-switch
              class="customSwitch"
              v-model="model.joiningGiftDiscountPercetangeType"
              label="toggle percentage discount"
              hide-details
            ></v-switch>
          </div>
          <v-checkbox
            v-model="model.joiningGiftMessage.enabled"
            label="Send members a message when they are eligible for this dicount?"
          ></v-checkbox>
          <div v-if="model.joiningGiftMessage.enabled">
            <v-radio-group
              v-model="model.joiningGiftMessage.type"
              row
              class="mt-0 ml-5"
            >
              <custom-radio label="SMS" value="SMS"/>
              <custom-radio label="Email" value="Email"/>
            </v-radio-group>
            <v-textarea
              v-model="model.joiningGiftMessage.text"
              class="mx-2 mt-n7"
              hint="Message"
              persistent-hint
              rows="3"
              :placeholder="'At Coffee Star we like warm welcomes!\nHere is something from us for your first purchase as a member, enjoy!'"
              :rules="[rules.required]"
            ></v-textarea>
          </div>
        </form-section>

        <!-- Birthday Discount -->
        <form-section header="3. Birthday Gift—Cash Discount" optional>
          <div class="inline">
            <div>Enter <b>Check-Level</b> Discount</div>
            <v-text-field
              class="minimal"
              :suffix="model.joiningBirthdayDiscountPercetangeType ? '%' : null"
              :prefix="model.joiningBirthdayDiscountPercetangeType ? null : '$'"
              placeholder="5"
              v-model="model.birthdayGiftDiscount"
              :rules="[rules.number]"
            />
            <v-switch
              class="customSwitch"
              v-model="model.joiningBirthdayDiscountPercetangeType"
              label="toggle percentage discount"
              hide-details
            ></v-switch>
            </div>
            <v-checkbox
              v-model="model.birthdayGiftMessage.enabled"
              label="Send members a message when they are eligible for this dicount?"
            ></v-checkbox>
            <div v-if="model.birthdayGiftMessage.enabled">
            <v-radio-group
              v-model="model.birthdayGiftMessage.type"
              row
              class="mt-0 ml-5"
            >
              <custom-radio label="SMS" value="SMS"/>
              <custom-radio label="Email" value="Email"/>
            </v-radio-group>
              <v-textarea
                v-model="model.birthdayGiftMessage.text"
                class="mx-2 mt-n7"
                rows="2"
                hint="Message"
                :placeholder="'Happy Birthday!\nWe invite you to redeem you birthday gift at one of our stores !'"
                persistent-hint
                :rules="[rules.required]"
              ></v-textarea>
              <div class="inline">&nbsp;</div>
            </div>
        </form-section>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import FormSection from "../FormSection";
import CustomRadio from "../CustomRadio";

export default {
  props: ["context"],
  components: {
    Step,
    FormSection,
    CustomRadio,
  },
  data() {
    return {
      valid: false,
      rules: {
        required: (v) => !!v || "Field is required",
        number: (v) =>
          v == null || !isNaN(Number(v)) || "Value must be a number",
        percentage: (v) =>
          (!isNaN(Number(v)) && v >= 0 && v <= 100) ||
          "Value must be a percentage",
      },
      model: {
        joiningGiftDiscount: null,
        joiningGiftDiscountPercetangeType: false,
        joiningBirthdayDiscountPercetangeType: null,
        joiningGiftMessage: {
          enabled: false,
          type: 'SMS',
          text: null,
        },
        birthdayGiftDiscount: null,
        birthdayGiftDiscountPercetangeType: false,
        birthdayGiftMessage: {
          enabled: false,
          type: 'SMS',
          text: null,
        },
        ...this.context.submittedData,
      },
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", { ...this.$data.model });
    },
  },
};
</script>
